import { Component, ReactNode } from 'react';

import { twclsx } from 'utils/twclsx';

import Icon from './Icon';

interface MessageProps {
    type: string | null;
    children: ReactNode;
    className?: string;
    onClick?: () => void;
}

interface MessageState {
    messageStyle: object;
}

export default class Message extends Component<MessageProps, MessageState> {
    constructor(props: MessageProps) {
        super(props);
        this.state = {
            messageStyle: {
                success: {
                    background: '#ddfedb',
                    color: '#16a34a',
                    icon: (
                        <Icon currentColor={'#16a34a'}>
                            <path d="M5 7.2a2.2 2.2 0 0 1 2.2 -2.2h1a2.2 2.2 0 0 0 1.55 -.64l.7 -.7a2.2 2.2 0 0 1 3.12 0l.7 .7c.412 .41 .97 .64 1.55 .64h1a2.2 2.2 0 0 1 2.2 2.2v1c0 .58 .23 1.138 .64 1.55l.7 .7a2.2 2.2 0 0 1 0 3.12l-.7 .7a2.2 2.2 0 0 0 -.64 1.55v1a2.2 2.2 0 0 1 -2.2 2.2h-1a2.2 2.2 0 0 0 -1.55 .64l-.7 .7a2.2 2.2 0 0 1 -3.12 0l-.7 -.7a2.2 2.2 0 0 0 -1.55 -.64h-1a2.2 2.2 0 0 1 -2.2 -2.2v-1a2.2 2.2 0 0 0 -.64 -1.55l-.7 -.7a2.2 2.2 0 0 1 0 -3.12l.7 -.7a2.2 2.2 0 0 0 .64 -1.55v-1" />
                            <path d="M9 12l2 2l4 -4" />
                        </Icon>
                    ),
                },
                message: {
                    background: '#ffffff',
                    color: '#dddddd',
                    icon: (
                        <Icon currentColor={'#dddddd'}>
                            <path d="M3 7a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v10a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-10z" />
                            <path d="M3 7l9 6l9 -6" />
                        </Icon>
                    ),
                },
                default: {
                    background: '#f1f1f1',
                    color: '#dddddd',
                    icon: (
                        <Icon currentColor={'#dddddd'}>
                            <path d="M3 7a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v10a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-10z" />
                            <path d="M3 7l9 6l9 -6" />
                        </Icon>
                    ),
                },
                error: {
                    background: '#fedbdb',
                    color: '#ef4444',
                    icon: (
                        <Icon currentColor={'#ef4444'}>
                            <path d="M12 21a9 9 0 0 0 9 -9a9 9 0 0 0 -9 -9a9 9 0 0 0 -9 9a9 9 0 0 0 9 9z" />
                            <path d="M8.5 8.5l7 7" />
                            <path d="M8.5 15.5l7 -7" />
                        </Icon>
                    ),
                },
                warning: {
                    background: '#fdfedb',
                    color: '#a16207',
                    icon: (
                        <Icon currentColor={'#a16207'}>
                            <path d="M12 9v4" />
                            <path d="M10.363 3.591l-8.106 13.534a1.914 1.914 0 0 0 1.636 2.871h16.214a1.914 1.914 0 0 0 1.636 -2.87l-8.106 -13.536a1.914 1.914 0 0 0 -3.274 0z" />
                            <path d="M12 16h.01" />
                        </Icon>
                    ),
                },
                info: {
                    background: '#dbeafe',
                    color: '#0369a1',
                    icon: (
                        <Icon currentColor={'#0369a1'}>
                            <path d="M3 12a9 9 0 1 0 18 0a9 9 0 0 0 -18 0" />
                            <path d="M12 9h.01" />
                            <path d="M11 12h1v4h1" />
                        </Icon>
                    ),
                },
            },
        };
    }

    render() {
        const { children, className, type } = this.props;
        let style = this.state.messageStyle['message'];
        if (this.props.type) {
            style = this.state.messageStyle[this.props.type];
        }
        return (
            <div
                style={{ backgroundColor: style.background, color: style.color }}
                className={twclsx('block', 'rounded-md', 'p-2', className)}
                onClick={this.props.onClick}
            >
                <div className="flex h-full ">
                    <div className="flex-shrink-0">
                        {this.props.type
                            ? this.state.messageStyle[this.props.type].icon
                            : this.state.messageStyle['message'].icon}
                    </div>
                    <div className="ml-3 flex flex-1 md:justify-between min-w-56 first-letter-uppercase">
                        {children}
                    </div>
                </div>
            </div>
        );
    }
}
